import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import "./inputDateRange.scss"

const InputDateRange = ({ dateValueFilter, setDateValueFilter, flatpickrRef }) => {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <i
        className="fas fa-calendar-alt"
        style={{
          position: "absolute",
          left: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#6c757d",
          fontSize: "14px",
          pointerEvents: "none",
        }}
      />

      <Flatpickr
        className={`d-block`}
        placeholder="Select date range"
        value={dateValueFilter}
        onChange={(dates, dateStr, instance) => {
          setDateValueFilter(dates);
          if (instance.altInput) {
            if (dates.length > 0) {
              instance.altInput.style.backgroundColor = "#EFF2F7";
              instance.altInput.classList.add("input-date-selected");
            } else {
              instance.altInput.classList.remove("input-date-selected");
            }
          }
        }}
        onClose={(dates) => {
          if (dates.length === 1) {
            setDateValueFilter([dates[0], dates[0]]);
          }
        }}
        options={{
          mode: "range",
          altInput: true,
          altFormat: "F j, Y",
          dateFormat: "Y-m-d",
          allowInput: true,
        }}
        onReady={(selectedDates, dateStr, instance) => {
          flatpickrRef.current = instance;
          if (instance.altInput) {
            instance.altInput.addEventListener("keydown", (e) => {
              e.preventDefault();
            });
          }
          instance.altInput.style.paddingLeft = "38px";
        }}
      />
      {dateValueFilter &&(
        <button
          type="button"
          onClick={() => {
            setDateValueFilter("");

            if (flatpickrRef.current?.altInput) {
              flatpickrRef.current.altInput.classList.remove(
                "input-date-selected"
              );
              flatpickrRef.current.altInput.style.backgroundColor = "#FFF";
              flatpickrRef.current.altInput.value = "";
            }
          }}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            color: "#888",
          }}
        >
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>
  );
};

export default InputDateRange;
